import { BaseComponentProps } from "../core/components/baseComponentProps";
import { Config } from "../core/config/config";
import React from "react";

export default class LinkedTasks extends React.Component<LinkedTasksProps, any> {
    private mapToLinks(item: LinkedTaskItem, index: number, array: LinkedTaskItem[]) {
        return (
            <React.Fragment key={kendo.guid()}>
                <a href={Config.baseUrl + "RecurringTask/Edit?id=" + item.TaskId} target="_blank">{item.TaskNo}</a>
                {index == (array.length-1) ? null : ", "}
            </React.Fragment>
        );
    }

    render() {
        return <div style={{ marginTop: "9px" }}> {this.props.value.map(this.mapToLinks)}</div>;
    }
}

interface LinkedTasksProps extends BaseComponentProps {
    value: LinkedTaskItem[];
}

interface LinkedTaskItem {
    TaskId: string
    TaskNo: string;
}